import React, { Component } from 'react';
import img from '../../../assets/Broker/BrokerProfile_Content/43b3cdff31e13bf06d6909460fa35b2c_html_66db3253ab2f58e3.png';
import img1 from '../../../assets/Broker/BrokerProfile_Content/43b3cdff31e13bf06d6909460fa35b2c_html_6e3288baf8a964ff.png';
class BrokerprofileContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Broker Profile:</b></p>
                <p>Broker Profile  contains the general information of broker. Broker personal details is displayed in General tab, User can edit Personal Information (Phone Number). Broker can add Address under Address section.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
                <p ><b > Compliance:</b></p>
                <p>Broker can upload Compliance under Compliance tab. Uploaded license and document will be in submitted status. Admin approves the document and license.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default BrokerprofileContent;
